import { render, staticRenderFns } from "./closeOpenRequestModal.vue?vue&type=template&id=12de7c7c&scoped=true"
import script from "./closeOpenRequestModal.vue?vue&type=script&lang=js"
export * from "./closeOpenRequestModal.vue?vue&type=script&lang=js"
import style0 from "./closeOpenRequestModal.vue?vue&type=style&index=0&id=12de7c7c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12de7c7c",
  null
  
)

export default component.exports